import { ssv2308ExcecRadarCotacResource } from '@/shared/api.resource';

import {
  FETCH_SSV2308_EXCEC_RADAR_COTAC_BY_ID,
  FETCH_PAGINATED_SSV2308_EXCEC_RADAR_COTACS,
  UPDATE_SSV2308_EXCEC_RADAR_COTAC,
  CREATE_SSV2308_EXCEC_RADAR_COTAC,
  DELETE_SSV2308_EXCEC_RADAR_COTAC,
  RESET_SSV2308_EXCEC_RADAR_COTAC_FILTERS,
  RESET_SSV2308_EXCEC_RADAR_COTAC,
  RESET_SSV2308_EXCEC_RADAR_COTACS_LIST,
} from './actions.type';

import {
  SET_SSV2308_EXCEC_RADAR_COTAC,
  SET_PAGINATED_SSV2308_EXCEC_RADAR_COTACS,
  RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_FILTERS,
  RESET_STATE_SSV2308_EXCEC_RADAR_COTAC,
  RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_LIST,
} from './mutations.type';

const initialState = {
  ssv2308ExcecRadarCotacFilters: {},
  ssv2308ExcecRadarCotac: {},
  paginatedSsv2308ExcecRadarCotacs: {
    content: [],
    totalElements: 0,
    size: 0
  }
};

export const state = JSON.parse(JSON.stringify(initialState));

export const actions = {
  async [FETCH_SSV2308_EXCEC_RADAR_COTAC_BY_ID](context, id) {
    const { data } = await ssv2308ExcecRadarCotacResource.get({ id: id });
    context.commit(SET_SSV2308_EXCEC_RADAR_COTAC, data);
    return data;
  },
  async [FETCH_PAGINATED_SSV2308_EXCEC_RADAR_COTACS](context, params) {
    const { data } = await ssv2308ExcecRadarCotacResource.query(params);
    context.commit(SET_PAGINATED_SSV2308_EXCEC_RADAR_COTACS, data);
    return data;
  },
  async [CREATE_SSV2308_EXCEC_RADAR_COTAC](context) {
    const { data } = await ssv2308ExcecRadarCotacResource.save(state.ssv2308ExcecRadarCotac);
    context.commit(SET_SSV2308_EXCEC_RADAR_COTAC, data);
    return data;
  },
  async [UPDATE_SSV2308_EXCEC_RADAR_COTAC](context, id) {
    const { data } = await ssv2308ExcecRadarCotacResource.update({ id: id }, state.ssv2308ExcecRadarCotac);
    context.commit(SET_SSV2308_EXCEC_RADAR_COTAC, data);
    return data;
  },
  [DELETE_SSV2308_EXCEC_RADAR_COTAC](context, id) {
    return ssv2308ExcecRadarCotacResource.delete({ id: id });
  },
  [RESET_SSV2308_EXCEC_RADAR_COTAC_FILTERS]({ commit }) {
    commit(RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_FILTERS);
  },
  [RESET_SSV2308_EXCEC_RADAR_COTAC]({ commit }) {
    commit(RESET_STATE_SSV2308_EXCEC_RADAR_COTAC);
  },
  [RESET_SSV2308_EXCEC_RADAR_COTACS_LIST]({ commit }) {
    commit(RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_LIST);
  }
};

export const mutations = {
  [SET_SSV2308_EXCEC_RADAR_COTAC](state, ssv2308ExcecRadarCotac) {
    state.ssv2308ExcecRadarCotac = ssv2308ExcecRadarCotac;
  },
  [SET_PAGINATED_SSV2308_EXCEC_RADAR_COTACS](state, paginatedSsv2308ExcecRadarCotacs) {
    state.paginatedSsv2308ExcecRadarCotacs = paginatedSsv2308ExcecRadarCotacs;
  },
  [RESET_STATE_SSV2308_EXCEC_RADAR_COTAC](state) {
    state.ssv2308ExcecRadarCotac = JSON.parse(JSON.stringify(initialState.ssv2308ExcecRadarCotac));
  },
  [RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_FILTERS](state) {
    state.ssv2308ExcecRadarCotacFilters = JSON.parse(JSON.stringify(initialState.ssv2308ExcecRadarCotacFilters));
  },
  [RESET_STATE_SSV2308_EXCEC_RADAR_COTAC_LIST](state) {
    state.paginatedssv2308ExcecRadarCotacs = JSON.parse(JSON.stringify(initialState.paginatedSsv2308ExcecRadarCotacs));
  }
};

export const getters = {
  ssv2308ExcecRadarCotac(state) {
    return state.ssv2308ExcecRadarCotac;
  },
  ssv2308ExcecRadarCotacFilters(state) {
    return state.ssv2308ExcecRadarCotacFilters;
  },
  paginatedSsv2308ExcecRadarCotacs(state) {
    return state.paginatedSsv2308ExcecRadarCotacs;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}